export default __webpack_public_path__ + "static/media/Matting_Dashboard_banner_2.7012a8ec.jpg";